/**
 * AxonometricMode icon — axonometric / isometric cube.
 * Represents the 3D axonometric view mode.
 * Uses `currentColor` for stroke.
 */
export function AxonometricMode({
	className,
	width = '1em',
	height = '1em',
	...rest
}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 32"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeMiterlimit="10"
			aria-hidden="true"
			className={className}
			{...rest}
		>
			<g transform="rotate(180 16 16)">
				<polygon
					strokeWidth="2"
					points="4,9.7 4,23.2 16,30 28,23.2 28,9.7 16,3 "
				/>
				<polyline
					strokeWidth="1"
					points="4,10.2 16,17 28,10.2 "
				/>
				<line
					strokeWidth="1"
					x1="16"
					y1="30"
					x2="16"
					y2="17"
				/>
			</g>
		</svg>
	);
}
